import angular from 'angular';

import summaryBlockComponent from './summary-block.component';

export default angular.module('dbm.dashboard.components.summary-block', [])
.component('dbmSummaryBlock', summaryBlockComponent)
.name;



// WEBPACK FOOTER //
// ./src/app/authorized/newDashBoard/components/summary-block/index.js